import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const data = [
  { name: "Local Dispatch", services: 90 },
  { name: "Interstate Delivery", services: 36 },
  { name: "Express Delivery", services: 20 },
  { name: "Bulk package", services: 60 },
  { name: "Schedulen pickup", services: 10 },
  { name: "Last mile Delivery", services: 15 },
];

const ServicesRendered = () => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data} barSize={20}>
        <CartesianGrid vertical={false} stroke="#E5E7EB" strokeOpacity={0.7} />
        <XAxis dataKey="name" />
        <YAxis ticks={[0, 25, 50, 75, 100]} tick={{ fontWeight: "700" }} />
        <Tooltip />
        <Bar dataKey="services" fill="#3b82f6" stackId="a" name="Services" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ServicesRendered;
